export default __webpack_public_path__ + "static/media/info_start.min.8519f536.png";